import {
  Button,
  Modal,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  footerButtonWidth,
  cancelButtonStyles,
  registerPatientButtonStyles,
} from "../../common/commonStyles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";

const PatientResistrationForm = ({
  open,
  handleClose,
  formData,
  handleInputChange,
  handleCreatePatient,
  isEditClicked,
  validationErrors,
}) => {
  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            flexGrow: 1,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            padding: "15px 25px 15px 25px",
            width: "800px",
            maxWidth: "800px",
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <Grid container>
            <Grid item xs={12}>
              <h3 className="form-title">
                {isEditClicked ? "Edit Patient" : "Patient Registration Form"}
              </h3>
            </Grid>
          </Grid>
          <Divider sx={{ marginBottom: "20px" }} />
          <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
            <Grid size={6}>
              <TextField
                fullWidth
                label="Patient Name"
                size="small"
                margin="none"
                name="patient_name"
                value={formData.patient.patient_name}
                onChange={handleInputChange}
                className="custom-textfield"
                error={!!validationErrors.patient_name}
                helperText={validationErrors.patient_name}
              />
            </Grid>
            <Grid size={6}>
              <TextField
                fullWidth
                label="Parent Name"
                size="small"
                margin="none"
                name="name"
                value={formData.user.name}
                onChange={handleInputChange}
                className="custom-textfield"
                error={!!validationErrors.name}
                helperText={validationErrors.name}
              />
            </Grid>
            <Grid size={4}>
              <label style={{fontSize:'12px'}}>Date of Birth</label>
              <TextField
                margin="none"
                type="date"
                name="date_of_birth"
                value={formData.patient.date_of_birth}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="custom-textfield"
                error={!!validationErrors.date_of_birth}
                helperText={validationErrors.date_of_birth}
              />
            </Grid>
            <Grid size={4} sx={{ marginTop: "20px" }}>
              <TextField
                fullWidth
                label="Phone Number"
                size="small"
                margin="none"
                name="phone_number"
                value={formData.user.phone_number}
                onChange={handleInputChange}
                className="custom-textfield"
                error={!!validationErrors.phone_number}
                helperText={validationErrors.phone_number}
              />
            </Grid>
            <Grid size={4} sx={{ marginTop: "20px" }}>
              <TextField
                fullWidth
                label="Email"
                size="small"
                margin="none"
                name="email"
                value={formData.user.email}
                onChange={handleInputChange}
                className="custom-textfield"
                error={!!validationErrors.email}
                helperText={validationErrors.email}
              />
            </Grid>
            <Grid size={6}>
              <TextField
                fullWidth
                label="Address"
                size="small"
                margin="none"
                name="address"
                value={formData.user.address}
                onChange={handleInputChange}
                className="custom-textfield"
                error={!!validationErrors.address}
                helperText={validationErrors.address}
              />
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth sx={{ minWidth: 120 }} size="small">
                <InputLabel className="custom-selectfield-label">
                  Gender
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="gender"
                  value={formData.patient.gender}
                  onChange={handleInputChange}
                  label="Gender"
                  className="custom-selectfield"
                >
                  <MenuItem value={"male"}>Male</MenuItem>
                  <MenuItem value={"female"}>Female</MenuItem>
                  <MenuItem value={"other"}>Other</MenuItem>
                </Select>
                {validationErrors.gender && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "0.8rem",
                      margin: "3px 0 0",
                    }}
                  >
                    {validationErrors.gender}
                  </p>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <div className="register_btn">
            <Button
              variant="contained"
              sx={[registerPatientButtonStyles, footerButtonWidth]}
              size="small"
              onClick={() => {
                handleCreatePatient();
              }}
            >
              {isEditClicked ? "Edit" : "Create"}
            </Button>
            <Button
              variant="contained"
              sx={[cancelButtonStyles, footerButtonWidth]}
              size="small"
              onClick={() => {
                handleClose();
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default PatientResistrationForm;
